<template>
	<div>
		<transition name="fade">
		<div v-if="!isShowEditor && showButtonEditor" @click="isShowEditor = true" class="floating-composition-btn" v-tooltip="$t('Show editor')">
			<i class="material-icons">keyboard_arrow_up</i>
		</div>
		</transition>
		<div class="text-center">
			<loading :active.sync="isFetching" :is-full-page="fullPage" :background-color="colorOverlay" :color="colorLoading">
				<template slot="before">
					<div class="absolute text-lg loading-logo">
						<img src="/img/icon-512.png" height="20" width="20" class="d-inline-block align-top" alt="Grafias">
					</div>
				</template>
				<template slot="after">
					<div class="absolute text-lg loading-text">Bottling Composition...</div>
				</template>
			</loading>
		</div>
		<div class="composition-editor" v-if="!isFetching">
			<div class="composition-wrapper d-flex">
				<!-- NEW LAYOUT -->
				<!-- <modal-composition :hide-footer="true" v-show="(isShowEditor && !item.user_id) || (isShowEditor && (item.user_id === user.id))"> -->
				<modal-composition :hide-footer="true" v-show="(isShowEditor && !item.user_id) || (isShowEditor)">
				<template slot="header">
					<md-menu
						md-size="medium"
						md-align-trigger>
						<button
							type="button"
							class="btn-icon btn-brand-composition btn"
							md-menu-trigger>
							<img src="/img/icon-512.png" class="navbar-brand-composition" alt="Grafias">
							<i class="material-icons pb-1 mt-1 ml-2">expand_more</i>
						</button>
						<md-menu-content class="mt-1">
							<md-menu-item @click="goTo('/')">
								<label class="link-white-nodecor">{{ $t('Dashboard') }}</label>
							</md-menu-item>
							<md-menu-item @click="isProgramMonitorVisible = true">
								<label class="link-white-nodecor">{{ $t('Device Monitor') }}</label>
							</md-menu-item>
							<md-menu-item @click="goTo('/rundowns')">
								<label class="link-white-nodecor">{{ $t('Rundown') }}</label>
							</md-menu-item>
							<md-menu-item @click="goTo('/displays')">
								<label class="link-white-nodecor">{{ $t('View Output') }}</label>
							</md-menu-item>
						</md-menu-content>
					</md-menu>
					<div class="form-group col-md-3 mb-0">
						<custom-input
							align="left"
							:label="$t('Name')"
							:required="true"
							:restrictChar="true"
							v-model="item.name"
						/>
					</div>
					<div class="d-flex justify-content-between">
						<div class="mr-2">
							<button @click="copyUrl()"
								class="btn btn-default btn-sm text-uppercase btn-action-composition">
								{{ $t('Get URL') }}
							</button>
						</div>
						<div class="mr-2">
							<button @click="isShowEditor = false"
								class="btn btn-default btn-sm text-uppercase btn-action-composition">
								{{ $t('Hide Editor') }}
							</button>
						</div>
						<div>
							<button @click="goToFullscreen"
								class="btn btn-default btn-icon btn-action-composition">
								<i class="material-icons">fullscreen</i>
							</button>
						</div>
						<div class="mr-8">
							<!-- <button @click="saveAndExit()"
								v-if="!isShowEditor"
								class="btn btn-primary btn-sm text-uppercase btn-action-composition-2">
								{{ $t('save & exit') }}
							</button> -->
							<!-- <button @click="save()"
								v-if="isShowEditor"
								class="btn btn-primary btn-sm btn-action-composition-2">
								{{ $t('save') }}
							</button> -->
							<div class="btn-group btn-action-composition-2 mr-5" role="group">
								<button :disabled="item.name === ''" @click="save()" type="button" class="btn btn-primary btn-sm btn-action-composition-2">Save</button>
								<!-- save as -->
								<!-- <md-menu
									class="h-fc mr-4"
									md-size="small"
									md-direction="bottom-end"
									md-align-trigger>
									<md-button
										class="btn btn-primary dropdown-toggle save-button-prefix btn-action-composition-2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
										:md-ripple="false"
										md-menu-trigger>
										<i class="material-icons md-18 black-color-icon">expand_more</i>
									</md-button>
									<md-menu-content>
										<md-menu-item @click="save()">{{ $t('Save as new Composition') }}</md-menu-item>
									</md-menu-content>
								</md-menu> -->
							</div>
							<!-- <div class="btn-group" role="group">
							</div> -->
							<button v-if="isShowEditor && !isShowCloseButton" class="btn-icon btn pr-1 btn-action-composition-3"
								v-tooltip="tooltipClose" @click="closeEditor">
							<i class="material-icons" v-if="!isShowCloseButton">close</i></button>
						</div>
					</div>
				</template>
				<template slot="body">
					<div class="main-modal-composition">
						<div class="tab-menus d-flex ml-0">
							<div
								class="tab-menu ml-0"
								:class="{ 'active': tab === 'background' }"
								@click="tab = 'background'">
								{{ $t('Background') }}
							</div>
							<div
								class="tab-menu"
								:class="{ 'active': tab === 'videoInput' }"
								@click="tab ='videoInput'">
								{{ $t('Video Input') }}
							</div>
							<div
								class="tab-menu"
								:class="{ 'active': tab === 'layout' }"
								@click="tab ='layout'">
								{{ $t('Layout') }}
							</div>
						</div>
						<div>
							<div v-show="tab === 'background'" class="mt-2">
								<!-- component Background -->
								<CompositionBackground @selectBackground="selectBackground"/>
							</div>
							<div v-show="tab === 'videoInput'" class="mt-2">
								<label>{{$t('Select Video Input')}}</label>
								<!-- component Video Input -->
								<CompositionVideoInput @selectVideoSource="selectVideoSource"/>
							</div>
							<div v-show="tab === 'layout'" class="mt-2">
								<label>{{$t('Select Layout for your Composition')}}</label>
								<!-- component Layout -->
								<CompositionLayout @selectLayout="showVideoInputView"/>
							</div>
						</div>
					</div>
				</template>
				</modal-composition>
				<!-- Main Route View -->
				<canvas ref="c1" width="1920" height="1080" class="composition-canvas"> </canvas>
				<modal-program-monitor
					@close="isProgramMonitorVisible = false"
					v-if="isProgramMonitorVisible">
				</modal-program-monitor>
				<span v-hotkey="keymap"></span>
			</div>
		</div>
</div>
</template>

<script>
import $ from 'jquery';
import Loading from 'vue-loading-overlay';
import { mapActions, mapGetters } from 'vuex';
import ModalProgramMonitor from './ModalProgramMonitor.vue';
import CompositionBackground from '@/components/CompositionBackground.vue';
import CompositionVideoInput from '@/components/CompositionVideoInput.vue';
import CompositionLayout from '@/components/CompositionLayout.vue';
import compositionsApi from '@/api/compositions';
import ModalComposition from '@/components/ModalComposition.vue';
import { getAxiosErrorMessage, randomString } from '@/lib/helper';
import CustomInput from '@/components/CustomInput.vue';
import layoutsApi from '@/api/layouts';


let videoInterval;
const defaultComposition = {
	name: '',
	file_path: '',
	is_archived: '',
	layout_id: '',
	device_id: '',
};
export default {
	name: 'CompositionEditor',
	components: {
		CompositionBackground,
		CompositionVideoInput,
		CompositionLayout,
		ModalComposition,
		CustomInput,
		ModalProgramMonitor,
		Loading,
	},
	data() {
		return {
			title: 'Composition',
			viewMenu: false,
			top: '0px',
			left: '0px',
			page: 1,
			limit: 25,
			orderBy: 'id',
			sortBy: 'asc',
			keyword: '',
			isAll: false,
			items: [],
			item: defaultComposition,
			selected: null,
			stream: null,

			isBackgroundActive: false,
			isVideoInputActive: false,
			isLayoutActive: false,
			isFullScreen: false,
			isShowEditor: false,
			isShowCloseButton: false,
			canvasX: 0,
			canvasY: 0,
			canvasWidth: 0,
			canvasHeight: 0,
			layout: null,
			resolution: {},
			activeLayout: '',
			activeResolution: '',
			activeBackground: '',
			mode: 'save',
			isFullView: false,
			tab: 'background',
			isProgramMonitorVisible: false,
			showButtonEditor: false,
			timer: null,
			isFetching: false,
			// loader
			fullPage: true,
			colorOverlay: '#000000',
			colorLoading: '#FFFFFF',
		};
	},
	watch: {
		'$route.params.id': {
			handler(id) {
				if (id) {
					this.mode = 'update';
				} else {
					this.mode = 'save';
				}
				// this.fetch();
			},
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
		}),
		backgroundExpandIcon() {
			const expandIcon = this.isBackgroundActive ? 'expand_less' : 'expand_more';
			return expandIcon;
		},
		videoInputExpandIcon() {
			const expandIcon = this.isVideoInputActive ? 'expand_less' : 'expand_more';
			return expandIcon;
		},
		layoutInputExpandIcon() {
			const expandIcon = this.isLayoutActive ? 'expand_less' : 'expand_more';
			return expandIcon;
		},
		c1() {
			return this.$refs.c1;
		},
		ctx() {
			return this.c1.getContext('2d');
		},
		keymap() {
			return {
				one: () => {
					this.shortcutKeys('49');
				},
				two: () => {
					this.shortcutKeys('50');
				},
				three: () => {
					this.shortcutKeys('51');
				},
				four: () => {
					this.shortcutKeys('52');
				},
				five: () => {
					this.shortcutKeys('53');
				},
				six: () => {
					this.shortcutKeys('54');
				},
				seven: () => {
					this.shortcutKeys('55');
				},
				eight: () => {
					this.shortcutKeys('56');
				},
				nine: () => {
					this.shortcutKeys('57');
				},
				zero: () => {
					this.shortcutKeys('48');
				},
				plus: () => {
					this.shortcutKeys('189');
				},
				minus: () => {
					this.shortcutKeys('187');
				},
			};
		},
		activeRouteName() {
			return this.$route.name;
		},
		tooltipClose() {
			if (this.activeRouteName === 'CompositionEditorNew') {
				return 'Back to Dashboard';
			// eslint-disable-next-line
			} else if (this.activeRouteName === 'CompositionEditorUpdate') {
				return 'Back to Dashboard';
			// eslint-disable-next-line
			} else if (this.isShowEditor) {
				return 'Close Editor';
			}
			return 'Back to Dashboard';
		},
	},
	created() {
		const isEditor = this.$route.query && this.$route.query.editorVisible ? this.$route.query.editorVisible : '';
		if (isEditor) {
			this.isShowEditor = false;
		} else {
			this.isShowEditor = true;
		}
		this.isShowCloseButton = this.hasProperty(this.$route.query, 'showclosebutton');
		$(document).find('main').removeClass('main');
		$('html').css('overflow', 'hidden');
		if (this.$route.name === 'CompositionEditorView') {
			this.isFullView = true;
		}
		this.$nextTick().then(() => {
			this.item.name = '';
			this.setNavbarVisible(false);
			this.setDrawerVisible(false);
			const isUpdate = this.$route.params.id;
			this.item.name = this.item.name ? this.item.name : `COMP -${randomString(6)}`;
			if (isUpdate) {
				this.fetch();
				this.mode = 'update';
			}
		});
	},
	mounted() {
		// window.addEventListener('resize', this.onResize);
		// this.onResize();
		this.$el.addEventListener('mousemove', () => {
			this.showButtonEditor = true;
			clearTimeout(this.timer);
			this.timer = setTimeout(() => {
				this.showButtonEditor = false;
			}, 5000);
		});
		this.$el.addEventListener('mouseleave', () => {
			clearTimeout(this.timer);
			this.showButtonEditor = false;
		});
	},
	methods: {
		...mapActions({
			setNavbarVisible: 'setNavbarVisible',
			setDrawerVisible: 'setDrawerVisible',
		}),
		fetch() {
			this.isFetching = true;
			const callback = (response) => {
				this.item = response.data;
				this.selectBackground(this.item.file_path);
				this.fetchLayout();
				this.isFetching = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: this.$t(this.title),
					text: message,
				});
				this.isFetching = false;
			};
			const id = this.$route.params.id;
			compositionsApi.get(id, callback, errorCallback);
		},
		fetchLayout(reset = false, page) {
			if (reset) {
				this.page = 1;
				this.items = [];
			}
			if (page) {
				this.page = page;
			}
			// const params = this.fetchParams;
			const callback = (response) => {
				const layout = response.data;
				this.layout = layout;
				this.showVideoInputView(layout);
				if (this.item && this.item.device_id) {
					this.startCapture(this.item.device_id);
				}
			};
			const errorCallback = () => {
				// const message = getAxiosErrorMessage(e);
				// this.$notify({
				// 	group: 'app',
				// 	type: 'error',
				// 	title: this.$t(this.title),
				// 	text: message,
				// });
			};
			const layoutId = this.item.layout_id;
			layoutsApi.get(layoutId, callback, errorCallback);
		},
		saveAndExit() {
			const isExit = 1;

			this.save(isExit);
		},
		save(isExit = false) {
			if (this.item.name !== '' && this.item.file_path !== '' && this.item.layout_id !== '') {
				if (this.mode === 'save') {
					this.create(isExit);
				}
				if (this.mode === 'update') {
					this.update(isExit);
				}
			} else {
				let message = 'something went wrong';
				if (!this.item.name) message = 'please input name field';
				if (!this.item.file_path) message = 'please select image background';
				if (!this.item.layout_id) message = 'please select layout';

				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Update Composition',
					text: message,
				});
			}
		},
		create(isExit = false) {
			const params = {
				name: this.item.name,
				file_path: this.item.file_path,
				is_archived: 0,
				device_id: this.item.device_id,
				layout_id: this.item.layout_id,
			};
			const callback = (response) => {
				const composition = response.data;
				this.item = composition;
				this.$router.push(`/compositions/editor/${composition.id}`);
				if (isExit) {
					this.$router.push('/compositions/');
				}
				const message = response.message;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Create Composition',
					text: message,
				});
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Create Composition',
					text: message,
				});
			};
			compositionsApi.create(params, callback, errorCallback);
		},
		goToFullscreen() {
			const dpr = window.devicePixelRatio || 1;
			this.c1.width = 1920 * dpr;
			this.c1.height = 1080 * dpr; // in pixels
			const canvasElement = this.c1;
			this.drawBaseBackground();
			if (canvasElement.requestFullscreen) {
				canvasElement.requestFullscreen();
			} else if (canvasElement.mozRequestFullScreen) {
				canvasElement.mozRequestFullScreen(); /* Firefox */
			} else if (canvasElement.webkitRequestFullscreen) {
				canvasElement.webkitRequestFullscreen(); /* Chrome, Safari & Opera */
			} else if (canvasElement.msRequestFullscreen) {
				canvasElement.msRequestFullscreen(); /* IE/Edge */
			}
		},
		update(isExit = false) {
			const params = {
				name: this.item.name,
				file_path: this.item.file_path,
				is_archived: 0,
				device_id: this.item.device_id,
				layout_id: this.item.layout_id,
			};
			const callback = (response) => {
				if (isExit) {
					this.$router.push('/compositions/');
				}
				// const duplicatedItem = response.data;
				// this.items.push(duplicatedItem);
				const message = response.message;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Update Composition',
					text: message,
				});
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Update Composition',
					text: message,
				});
			};
			compositionsApi.update(this.item.id, params, callback, errorCallback);
		},
		copyUrl() {
			const tempInput = document.createElement('input');
			tempInput.value = `${process.env.VUE_APP_URL}/compositions/view/${this.item.id}`;
			document.body.appendChild(tempInput);
			tempInput.select();
			document.execCommand('copy');
			document.body.removeChild(tempInput);
			this.$notify({
				group: 'app',
				type: 'success',
				title: 'Composition',
				text: 'URL is copied to clipboard',
			});
		},
		drawBaseBackground() {
			this.ctx.drawImage(this.selectBackground(this.activeBackground), 0, 0);
		},
		showProgramView() {
			if (!this.isFullScreen) {
				this.canvasX = 0;
				this.canvasY = 0;
				this.canvasWidth = window.innerWidth;
				this.canvasHeight = window.innerHeight;
			} else {
				this.canvasX = 0;
				this.canvasY = 0;
				this.canvasWidth = 1920;
				this.canvasHeight = 1080;
			}
		},
		selectBackground(backgroundImage) {
			this.item.file_path = backgroundImage;
			this.activeBackground = backgroundImage;
			const baseImage = new Image();
			baseImage.onload = () => {
				this.ctx.drawImage(baseImage, 0, 0);
			};
			baseImage.src = backgroundImage;
			return baseImage;
		},
		selectVideoSource(device) {
			this.showVideoInputView();
			this.drawBaseBackground();
			this.item.device_id = device.deviceId;
			this.startCapture(device.deviceId);
		},
		startCapture(deviceId) {
			clearInterval(videoInterval);
			const mainSource = this.createVideoElement('mainSouce');
			try {
				navigator.mediaDevices.getUserMedia({
					video: {
						deviceId: { exact: deviceId },
					},
					audio: false,
				}).then((cameraStream) => {
					this.stream = cameraStream;
					mainSource.srcObject = cameraStream;
					mainSource.play();
					this.drawVideoToCanvas(this.ctx, mainSource);
				});
			} catch (err) {
				// print error here
			}
		},
		stopVideoOnly(stream) {
			if (stream) {
				stream.getTracks().forEach((track) => {
					if (track) {
						track.stop();
					}
				});
			}
		},
		showVideoInputView(layoutConfig) {
			if (document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement) {
				this.c1.width = 1920;
				this.c1.height = 1080;
				this.isFullScreen = true;
			} else {
				this.isFullScreen = false;
			}
			if (!layoutConfig && !this.layout) {
				const params = {
					canvas_x: 50,
					canvas_y: 100,
					canvas_width: 1440,
					canvas_height: 810,
					window_width: window.innerWidth,
					window_height: window.innerHeight,
				};
				this.drawCustomLayout(params);
			} else if (!layoutConfig && this.layout) {
				this.drawCustomLayout(this.layout);
			} else {
				this.item.layout_id = layoutConfig.id;
				this.drawCustomLayout(layoutConfig);
			}
			this.drawBaseBackground();// redraw the base layer
		},
		drawCustomLayout(layoutConfig) {
			this.canvasX = layoutConfig.canvas_x;
			this.canvasY = layoutConfig.canvas_y;
			this.canvasWidth = layoutConfig.canvas_width;
			this.canvasHeight = layoutConfig.canvas_height;
			this.c1.width = layoutConfig.window_width;
			this.c1.height = layoutConfig.window_height;
		},
		createVideoElement(className) {
			this.HTMLVideoElement = () => {};
			const videoElem = document.createElement('video');
			videoElem.className = className;
			videoElem.muted = true;
			videoElem.volume = 0;
			videoElem.width = 1280;
			videoElem.height = 720;
			return videoElem;
		},
		drawVideoToCanvas(ctx, videoElem) {
			videoInterval = window.setInterval(() => {
				ctx.drawImage(videoElem, this.canvasX, this.canvasY, this.canvasWidth, this.canvasHeight);
			}, 10);
		},
		hasProperty(obj, prop) {
			return Object.prototype.hasOwnProperty.call(obj, prop);
		},
		// eslint-disable-next-line no-unused-vars
		shortcutKeys(key) {
			// if (Array.isArray(this.layouts) && this.layouts.length) {
			// for (let index = 0; index < this.layouts.length; index++) {
			// 	const element = this.layouts[index];
			// 	if (this.hasProperty(element, 'shortcut_key')) {
			// 		if (element.shortcut_key === key) {
			// 			this.canvasX = element.canvas_x;
			// 			this.canvasY = element.canvas_y;
			// 			this.canvasWidth = element.canvas_width;
			// 			this.canvasHeight = element.canvas_height;
			// 			this.c1.width = element.window_width;
			// 			this.c1.height = element.window_height;
			// 			this.drawBaseBackground();
			// 		}
			// 	}
			// }
			// }
		},
		goTo(route) {
			// eslint-disable-next-line
			if (route === '/' || 'compositions') {
				this.item.name = '';
				const routeData = this.$router.push(route);
				window.open(routeData.href, '_self');
			} else {
				this.item.name = '';
				const routeData = this.$router.resolve(route);
				window.open(routeData.href, '_blank');
			}
		},
		closeEditor() {
			if (this.activeRouteName === 'CompositionEditorNew') {
				this.$router.push('/compositions');
			} else if (this.activeRouteName === 'CompositionEditorUpdate') {
				this.$router.push('/compositions');
			} else if (this.isShowEditor) {
				this.isShowEditor = false;
			}
		},
	},
	beforeDestroy() {
		$(document).find('main').addClass('main');
		$('html').css('overflow', 'visible');
		this.setNavbarVisible(true);
		this.setDrawerVisible(true);
		this.stopVideoOnly(this.stream);
	},
};
</script>
